
  export default {
    name: 'MenuItemLink',
    props: ['to'],
  };
